
const LOCAL = {
  ENV: 'local',
  //AUTH0_CLIENT_ID: 'hshUytGvDFmj0dpDnxHjGwiZ28TuJHHD',
  //AUTH0_DOMAIN: 'calitb.auth0.com'
  AUTH0_CLIENT_ID: 'dATI22c5jhpbx4psemvUcQsgdp56k41o',
  AUTH0_DOMAIN: 'assisthub.auth0.com',
  ADMIN_BASE_URL: 'http://localhost:8000/admin/v1',
  AH_BASE_URL: 'http://localhost:8000/platform/assisthub/v1',
  TALKDESK_INTG_URL: 'http://localhost:8000/wh/talkdesk/v1'
}

const DEV = {
  ENV: 'dev',
  AUTH0_CLIENT_ID: 'dATI22c5jhpbx4psemvUcQsgdp56k41o',
  AUTH0_DOMAIN: 'assisthub.auth0.com',
  ADMIN_BASE_URL: 'https://api.dev.bit6.com/admin/v1',
  AH_BASE_URL: 'https://api.dev.bit6.com/platform/assisthub/v1',
  TALKDESK_INTG_URL: 'https://api.dev.bit6.com/wh/talkdesk/v1'
}

const PROD = {
  ENV: 'prod',
  AUTH0_CLIENT_ID: 'SlOJdHmKS0GuZ32L5zo6AF8AocCv0spS',
  AUTH0_DOMAIN: 'assisthub.auth0.com',
  ADMIN_BASE_URL: 'https://api.prod.bit6.com/admin/v1',
  AH_BASE_URL: 'https://api.prod.bit6.com/platform/assisthub/v1',
  TALKDESK_INTG_URL: 'https://api.prod.bit6.com/wh/talkdesk/v1',
  ENABLED_CHANNELS: [
    'usms', 'ufbm', 'ubxc', 'uemail', 'utlg', 'uline', 'uwechat',
    'azendesk', 'aemail', 'asfsc', 'adeskcom'
  ]
}


let cfg = PROD;

const url = location.host;
if ( url.includes('local') ) {
  cfg = LOCAL;
}
else if ( url.includes('dev') ) {
  cfg = DEV;
}

module.exports = cfg;



// WEBPACK FOOTER //
// ./src/utils/config.js